<template>
<crud-layout :title="title" :subtitle="subtitle">

        <template v-slot:list>
            <surveys-list 
                       ref="list"
                       @update="update"
                       @delete="remove"
                       @show="show"
            
            />
        </template>
        
         <add-button v-if="$store.getters.hasPermission('SURVEYS_CREATE')" @click="create"></add-button>
      
        <surveys-create v-if="creating" 
                        :open="creating"
                        v-on:itemCreated="onItemCreated" 
                        v-on:close="creating=false" 
        />
        
        <surveys-update v-if="updating" 
                        :open="updating"
                        :item="itemToEdit" 
                        v-on:itemUpdated="onItemUpdated" 
                        v-on:close="updating=false" 
        />
          
        <surveys-show v-if="showing" 
                           :open="showing" 
                           :item="itemToShow"  
                           v-on:close="showing=false" 
         />

        <surveys-delete v-if="deleting" 
                         :open="deleting"
                         :item="itemToDelete"  
                         v-on:itemDeleted="onItemDeleted" 
                         v-on:close="deleting=false" 
        />

        <snackbar v-model="flash"/>

</crud-layout>
</template>

<script>
    
    import SurveysCreate from "./SurveysCreate";
    import SurveysUpdate from "./SurveysUpdate";
    import SurveysDelete from "./SurveysDelete";
    import SurveysShow from "./SurveysShow";
    import SurveysList from "./SurveysList";
    
     import {CrudLayout, AddButton, Snackbar} from "@dracul/common-frontend"
     
    export default {
        name: "SurveysCrudPage",
        components: {
            CrudLayout, AddButton, Snackbar,
            SurveysCreate, 
            SurveysUpdate, 
            SurveysDelete, 
            SurveysShow,
            SurveysList
        },
        data() {
            return {
                title: 'delivery.surveys.title',
                subtitle: 'delivery.surveys.subtitle',
                flash: null,
                creating: false,
                updating: false,
                deleting: false,
                showing: false,
                itemToEdit: null,
                itemToDelete: null,
                itemToShow: null,
            }
        },
        methods: {
            //On
            onItemCreated() {
                this.$refs.list.fetch()
                this.flash= this.$t("common.created")
            },
            onItemUpdated() {
                this.$refs.list.fetch()
                this.flash= this.$t("common.updated")
            },
            onItemDeleted() {
                this.$refs.list.fetch()
                this.flash= this.$t("common.deleted")
            },
            //Open
            create() {
                this.creating = true
            },
            update(item) {
                this.updating = true
                this.itemToEdit = item
            },
            show(item) {
                this.showing = true
                this.itemToShow = item
            },
            remove(item) {
                this.deleting = true
                this.itemToDelete = item
            }
        }
        
    }
</script>


